module.exports = __webpack_public_path__ + "static/onkar-b05764d013f57fb7470f02d1b8ae0f35.jpg";